import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Assistant search bar component.
 * Renders a search input with icon and translated placeholder text.
 * @returns {JSX.Element}
 */
export default function SearchBar() {
  const { t } = useLanguage()

  return (
    <div className="welcomeLineDiv welcomeSearch" tabIndex="-1">
      <input
        name="shortways-assistant-search-input"
        type="text"
        className="form-control form-control-sm search-document-input"
        placeholder={t("AssistantWindow.assistantWindowPlaceholder")}
        data-form-type="other"
      />
      <div className="searchIcon" data-testid="searchIcon" />
    </div>
  )
}
